<template>
  <div class="goods" :style="bannerFlag ? 'margin-top: 45px;':''">

    <div class="nav">

      <div class="w">

<!--        <a href="javascript:void(0)" @click="clickSort(0)" :class="{active:sortType === 0}">综合排序</a>
        <a href="javascript:void(0)" @click="clickSort(1)" :class="{active:sortType === 1}">销量排序</a>
        <a href="javascript:void(0)" @click="clickSort(2)" :class="{active:sortType === 2}">价格低到高</a>
        <a href="javascript:void(0)" @click="clickSort(3)" :class="{active:sortType === 3}">价格高到低</a> -->
        <a href="javascript:void(0)"  v-for="(val,i) in category" @click="clickSort(i,val)" :class="{active:sortType === i}">{{val}}</a>


        <div class="search-input">
          <el-input size="mini" placeholder="请输入商品信息" prefix-icon="el-icon-search" v-model="searchKey">
          </el-input>
        </div>

        <y-button text="搜索" classStyle="main-btn" @btnClick="loadMallGoods" style="margin-left: 10px;"></y-button>

      </div>

    </div>

    <div class="container w">
      <div v-loading="loading" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0)"
        style="min-height: 55vh;">

        <div class="goods-item w" v-if="goodsList.length > 0">
          <div class="goods-box">
            <mall-goods v-for="(item,i) in displayedData" :key="i" :msg="item" @openDialog="openDialog"></mall-goods>
          </div>
          <div class="pagination-wrap" v-if="goodsList.length > 0 && !error">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="currentPage" :page-sizes="[8, 16, 20]" :page-size="pageSize" :total="total"
              layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
          </div>
        </div>

        <div class="no-info" v-if="noGoods">
          <div class="no-data">
            <img src="/static/images/no-search.png">
            <br> 抱歉！暂时还没有商品
          </div>

          <section class="section">
            <y-shelf :title="recommendPanel.name">
              <div slot="content" class="recommend">
                <mall-goods :msg="item" v-for="(item,i) in recommendPanel.panelContents" :key="i"></mall-goods>
              </div>
            </y-shelf>
          </section>

        </div>

        <div class="no-info" v-if="error">
          <div class="no-data">
            <img src="/static/images/error.png">
            <br> 抱歉！出错了...
          </div>

          <section class="section">
            <y-shelf :title="recommendPanel.name">
              <div slot="content" class="recommend">
                <mall-goods :msg="item" v-for="(item,i) in recommendPanel.panelContents" :key="i"></mall-goods>
              </div>
            </y-shelf>
          </section>

        </div>

      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogFlag"
      width="30%"
      center>
      <p style="text-align: center;">
        <img src="/static/qr/qrcode.jpg"/>
        <br>
        <span>扫码进入<span style="color: #007aff;">医小智Mall</span>小程序下单</span>
      </p>
    </el-dialog>
  </div>
</template>
<script>
  import {mapState} from 'vuex'
  import list1 from "/assets/config/mall.js";
  import mallGoods from '/components/mallGoods'
  import YButton from '/components/YButton'
  import YShelf from '/components/YShelf'
  export default {
    data() {
      return {
        bannerFlag: false,
        loading: true,
        error: false,
        noGoods: false,
        goodsList: [],
        goodsList2: [],
        searchKey: '',
        sortType: -1,
        recommendPanel: [],
        currentPage: 1,
        total: 0,
        pageSize: 8,
        params: {
        	search: '',
        	sort: 'weigh',
        	order: 'asc',
        	page: 1,
        	filter: {},
        	op: {}
        },
        dialogFlag: false,
        category:[]
      }
    },
    computed: {
      ...mapState(['user']),
      displayedData() {
        // 首先检查是否有数据，避免错误
        if (!this.goodsList || this.goodsList.length === 0) {
          return [];
        }
        // 计算起始索引
        const startIndex = (this.currentPage - 1) * this.pageSize;
        // 计算结束索引
        const endIndex = startIndex + this.pageSize;
        // 根据索引范围返回当前页数据
        return this.goodsList.slice(startIndex, endIndex);
      },
    },
    methods: {
      // 控制顶部
      navFixed() {
        if (this.$route.path === '/mall') {
          var st = document.documentElement.scrollTop || document.body.scrollTop
          st >= 60 ? this.bannerFlag = true : this.bannerFlag = false
        } else {
          return
        }
      },
      handleSizeChange(val) {
        this.pageSize = val
        // this.loadMallGoods()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        // this.loadMallGoods()
      },
      // 价格排序
      clickSort(v,val) {
        this.sortType = v
        this.currentPage = 1
        let temp = []
        if(this.goodsList != this.goodsList2){
          this.goodsList = this.goodsList2
        }
        this.goodsList.forEach(item=>{
          if(val == item.category.name){
            temp.push(item)
          }
        })
        this.goodsList = temp
        // this.loadMallGoods()
      },
      loadMallGoods() {
        this.loading = true
        this.params.search = this.searchKey
        this.$api.get({
          url: '/product/lists',
          data: this.params
        }).then(res=>{
          let goodData = JSON.parse(res.msg)
          this.goodsList = goodData.data;
          this.goodsList2 = goodData.data;
          goodData.data.forEach(val=>{
            if(!this.category.includes(val.category.name)){
              this.category.push(val.category.name)
            }
          })
          // // this.params.page = goodData.data.current_page; //当前页码
          // // this.last_page = res.last_page; //总页码
          this.noGoods = this.goodsList.length > 0 ? false : true
          this.total = goodData.data.length;
          this.loading = false
        })
        // this.params.search = ''
        // setTimeout(() => {
        //   this.goodsList = list1
        //   this.noGoods = this.goodsList.length > 0 ? false : true
        //   this.total = this.goodsList.length
        //   this.loading = false
        // }, 1000);

      },
      openDialog(open){
        this.dialogFlag = open
      }
    },
    created() {
      // if(this.user.userType === '99'){
      //   this.$store.commit('common/recordNav',{navIndex: 3,navSubIndex: 0})
      // }else{
      //   this.$store.commit('common/recordNav',{navIndex: 4,navSubIndex: 0})
      // }
      this.loadMallGoods();
    },
    mounted() {
      this.navFixed()
      window.addEventListener('scroll', this.navFixed)
      window.addEventListener('resize', this.navFixed)
      document.title = "医小智 - 在线商城"
    },
    components: {
      mallGoods,
      YButton,
      YShelf
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  @import "../../assets/style/mixin";
  @import "../../assets/style/theme";

  .nav {

    height: 60px;
    line-height: 60px;

    >div {
      display: flex;
      align-items: center;

      a {
        padding: 0 20px;
        height: 100%;
        @extend %block-center;
        font-size: 12px;
        color: #999;

        &.active {
          color: #00a5d5;
        }

        &:hover {
          color: #00a5d5;
        }
      }

    }

  }

  .container {}

  .goods-item {
    display: flex;
    flex-direction: column;
  }

  .goods-box {
    >div {
      float: left;
      border: 1px solid #efefef;
    }
  }

  .pagination-wrap {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: 30px auto;
  }

  .no-info {
    padding: 100px 0;
    text-align: center;
    font-size: 30px;
    display: flex;
    flex-direction: column;

    .no-data {
      align-self: center;
    }
  }

  .section {
    padding-top: 8vw;
    margin-bottom: -5vw;
    width: 1218px;
    align-self: center;
  }

  .recommend {
    display: flex;

    >div {
      flex: 1;
      width: 25%;
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?b8e2ac98